import { FormGroup } from '@angular/forms';
import { Observable, map, of } from 'rxjs';
import { MemberResponseHelper } from './member-response-helper';
import { SharedMemberResponseService } from '../service/shared-member-response.service';
import { ChangeDetectorRef } from '@angular/core';
import { SurveySummaryDto } from '../model/surveySummaryDto';
import { NotifierService } from '@app/core/services/notifier-service';

export abstract class SurveyStepBase{
    //#region Public Variables
    public Title: string;
    public StepIndex: number
    public ActiveStep: boolean;
    public Form: FormGroup<any>;
    //#endregion Public Variables

    //#region Protected Variables
    protected SurveyResponseId: number = null;
    protected InitialFormValue: any = null;
    protected FormKey: keyof SurveySummaryDto;
    //#enndregion Protected Variables

    //#region Constructor
    constructor(
        title: string,
        stepIndex: number,
        activeStep: boolean,
        formKey: keyof SurveySummaryDto,
        protected changeDetectorRef: ChangeDetectorRef,
        protected notifierService: NotifierService,
        protected sharedMemberResponseService: SharedMemberResponseService){
            this.Title = title;
            this.StepIndex = stepIndex;
            this.ActiveStep = activeStep;
            this.FormKey = formKey;
        }
    //#endregion Constructor

    //#region Public Methods
    public get FormIsValid(): boolean{
        return this.Form.valid;
    }

    public OnSubmit(): Observable<boolean>{
        if (this.Form.valid) {
            return this.SaveForm();
          } else {
            this.notifierService.DisplayErrorMessage(
              'Mandatory fields must be filled out.'
            );
            return of(false);
          }
    }

    public SaveForm(): Observable<boolean> {
        const hasFormChanged: boolean = MemberResponseHelper.HasFormChanged(this.Form, this.InitialFormValue);
        if(!hasFormChanged){
            return of(true);
        }

        return this.HandleRequest().pipe(
            map((success: boolean) =>{
                if(success){
                    const data: any = this.GetFormData();
                    this.sharedMemberResponseService.UpdateSurveySummary(this.FormKey, data);
                    this.InitialFormValue = data;
                    return true;
                }

                return false
            })
        );
    }
    //#endregion Public Methods

    //#region Protected Methods
    protected InitStep(): void {
        this.SurveyResponseId = this.sharedMemberResponseService.GetSurveyResponseId();
        this.BuildForm();
        this.LoadData();

        this.InitialFormValue = this.Form.value;

        this.Form.valueChanges.subscribe(() => {
          this.changeDetectorRef.detectChanges();
        });
    }

    protected abstract BuildForm(): void;
    protected abstract GetFormData(): any;
    protected abstract HandleRequest(): Observable<boolean>;
    protected abstract LoadData(): void;
    //#endregion Protected Methods
}
